import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import { getAllVariantAPI, getSingleVariantAPI } from "./variant.api";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";

type IVariantServiceProps = Omit<IGetAllServiceProps, "stage_id">;

const useAllVariantService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: IVariantServiceProps) => {
  const [searchVariantQuery, setSearchVariantQuery] = useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(searchVariantQuery);
  const allVariantService = useQuery({
    queryKey: [...CACHE_KEYS.VARIANT, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllVariantAPI({
        searchParams: {
          include: "motor_model,motorfueltype,motortransmissiontype",
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchVariantQuery, setSearchVariantQuery },
    services: { allVariantService },
  };
};

const useSingleVariantService = ({
  singleVariantId,
  enableQuery = true,
}: {
  singleVariantId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.VARIANT, singleVariantId],
    queryFn: () => getSingleVariantAPI(singleVariantId),
    enabled: !!singleVariantId && enableQuery,
  });
};

export { useAllVariantService, useSingleVariantService };
